import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Mithril 2 does not completely rerender the page if a route change leads to the same route
 * (or the same component handling a different route). This util calls m.route.set, forcing a reonit.
 *
 * @see https://mithril.js.org/route.html#key-parameter
 */
export default function setRouteWithForcedRefresh(route, params, options) {
  if (params === void 0) {
    params = null;
  }
  if (options === void 0) {
    options = {};
  }
  const newOptions = _objectSpread({}, options);
  newOptions.state = newOptions.state || {};
  newOptions.state.key = Date.now();
  m.route.set(route, params, newOptions);
}
flarum.reg.add('core', 'common/utils/setRouteWithForcedRefresh', setRouteWithForcedRefresh);